export type OrderStatus =
  | 'checked_out'
  | 'confirmed'
  | 'dispatched'
  | 'delivering'
  | 'pending_cancellation'
  | 'delivery_unsuccessful'
  | 'completed'
  | 'canceled'
  | 'splitted'
  | 'draft';

export enum OrderStatusEnum {
  CheckedOut = 'checked_out',
  Confirmed = 'confirmed',
  Dispatched = 'dispatched',
  Delivering = 'delivering',
  PendingCancellation = 'pending_cancellation',
  DeliveryUnsuccessful = 'delivery_unsuccessful',
  Completed = 'completed',
  Canceled = 'canceled',
  Splitted = 'splitted',
  Draft = 'draft',
}

export * from './order.gql.generated';
